/**
 * @flow
 * Created by neo on 13.03.17.
 */
import {observer} from 'mobx-react';
import React, {Component} from 'react';
import FlightAircraft from '../../../Store/Flight/FlightAircraft';
import Aircraft from '../../../Store/Aircraft';
import { Input, Label } from 'reactstrap';
import { t } from 'i18next';

type Props = {
  flightAircraft: FlightAircraft,
};

@observer
export default class AircraftSelect extends Component {

  props: Props;

  getAircraftMedia(aircraft: Aircraft) {
    if(aircraft && aircraft.files && aircraft.files.length > 0) {
      return aircraft.files[0].file.url;
    }
    return null;
  }

  render() {

    const { flightAircraft: { aircraft_model: aircraft } } = this.props;
    
    if(aircraft) {
      const media = this.getAircraftMedia(aircraft);

      let mediaTag = null;
      if(media) {
        const imageStyle = {
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundImage: `url('${media}')`,
          height: '200px',
          borderRadius: '4px'
        };

        mediaTag = (
          <div className="mt-2 mb-4">
            <div style={imageStyle}></div>
          </div>
        );
      }

      return (
        <div>
          {mediaTag}
          <Label>1. {t('Flugzeug')}</Label>
          <Input type="select" bsSize="sm" value={aircraft.id} disabled>
            <option value={aircraft.id}>{aircraft.name}</option>
          </Input>
        </div>
      );
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/App/Flight/View/Booking/AircraftSelect.js